import React, { useCallback } from 'react';

import { HeaderLeft, HeaderRight } from './components';
import { type HeaderLeftProps, type HeaderRightProps } from './Header.props';

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerLeft` option of a native stack navigator.
 */
export const useHeaderLeft = (props: HeaderLeftProps) => {
  return useCallback(
    (headerProps: HeaderButtonProps) => <HeaderLeft {...headerProps} {...props} />,
    [props],
  );
};

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerRight` option of a native stack navigator.
 */
export const useHeaderRight = (props: HeaderRightProps) => {
  return useCallback(
    (headerProps: HeaderButtonProps) => <HeaderRight {...headerProps} {...props} />,
    [props],
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type HeaderButtonProps = {
  tintColor?: string;
  canGoBack?: boolean;
  label?: string;
};
